import { Box } from '@material-ui/core'
import React, { Component } from 'react'
import Herosection from '../commonComponents/Herosection'
// import CreateAccountForm from '../commonComponents/CreateAccountForm'
// import ClientCarousel from '../commonComponents/ClientCarousel'
// import Companies from '../commonComponents/Companies'
// import ReachingOut from '../commonComponents/ReachingOut'
import Filter from './Filter'

interface Props {
  // classes: any
}

class Courses extends Component<Props> {
  render() {
    return (
      <Box>
        <Herosection
          heading="Courses"
          // cardClass={"Herosection-herosectionLeftCards"}
          cardClass={"Herosection-herosectionCenterCards"}
          highlight={null}
          herosectionTitleClassName={"Herosection-herosectionSecondTitle"}
          herosectionClassName={"Herosection-herosectionSecondMessage"}
          // herosectionMessage={"Catering to various skill levels and programming languages. Here are some popular platforms and types of courses you might consider"}
          herosectionMessage={`The courses are designed to provide hand-on experience and practical knowledge to the students. Codezzy has experienced trainers who have in-depth knowledge and
          expertise in their respective domains. Apart from training, Codezzy also offers placement assistance to its students. Codezzy has state-of-the-art infrastructure with well-equipped
          classrooms, labs, and other facilities. The institute provides a friendly and supportive learning environment.`}
          herosectionBody={"Herosection-herosectionBodyFirst"}
          herosectionUnderlined={"Herosection-herosectionSecondUnderlined"}
        />
        <Filter />
        {/* <CreateAccountForm /> */}
        {/* <ClientCarousel /> */}
        {/* <Companies /> */}
        {/* <ReachingOut /> */}
      </Box>
    )
  }
}

export default Courses